import { render } from "./payroll-run-detail.vue?vue&type=template&id=387c64b0&scoped=true"
import script from "./payroll-run-detail.vue?vue&type=script&lang=js"
export * from "./payroll-run-detail.vue?vue&type=script&lang=js"

import "./payroll-run-detail.vue?vue&type=style&index=0&id=387c64b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387c64b0"]])

export default __exports__